import { createSelector } from 'reselect'
import { RootState } from 'redux/store'

const selectHasSmartFeatures = createSelector(
  (state: RootState) => state.user.hasSmartFeatures,
  (hasSmartFeatures: boolean) => hasSmartFeatures
)

export default selectHasSmartFeatures
